import { Pagination, Button, Select } from 'antd'
import CustomIcon from '../../CustomIcon/CustomIcon'

import './CustomPagination.css'

const CustomPagination = ({
  gridRef,
  totalPages,
  totalRecords,
  paginationCurrentPage,
  paginationPageSize,
  setPaginationPageSize,
  setPaginationCurrentPage,
  options
}) => {
  const goToPage = (page) => {
    setPaginationCurrentPage(page)
  }

  const onPageChange = (page) => {
    goToPage(page)
  }

  const onPageSizeChange = (pageSize) => {
    setPaginationPageSize(pageSize)
  }

  const itemRender = (page, type, originalElement) => {
    if (type === 'prev') {
      return <Button type="default"><CustomIcon name="ArrowLeft" /></Button>;
    }
    if (type === 'next') {
      return <Button type="default"><CustomIcon name="ArrowRight" /></Button>;
    }
    return originalElement;
  };

  return (
    <div className="data-grid-pagination flex-horizontal-gap-2">
      <Button type="default" className="data-grid-pagination-button" onClick={() => goToPage(1)} disabled={paginationCurrentPage === 1} >
        <CustomIcon name="ArrowLeftDouble" />
      </Button>
      <Pagination
        align="center"
        itemRender={itemRender}
        showSizeChanger={false}
        defaultCurrent={1}
        defaultPageSize={10}
        current={paginationCurrentPage}
        pageSize={paginationPageSize}
        total={totalRecords}
        onChange={onPageChange}
      />
      <Button type="default" className="data-grid-pagination-button" onClick={() => goToPage(totalPages)} disabled={paginationCurrentPage === totalPages || totalPages === 0} >
        <CustomIcon name="ArrowRightDouble" />
      </Button>
      {/* <Select
        defaultValue={paginationPageSize ?? 10}
        onChange={onPageSizeChange}
        options={[
          { value: 10, label: '10/Page' },
          { value: 25, label: '25/Page' },
          { value: 50, label: '50/Page' },
          { value: 100, label: '100/Page' },
        ]}
      /> */}
    </div>
  );
};

export default CustomPagination